import typeCheckUtils from '../utils/typeCheckUtils';

interface PetDTO {
  allowed: boolean | null;
  count: number | null;
}

interface PetsAllowedProps {
  cats?: boolean;
  catsDto?: PetDTO;
  largeDogs?: boolean;
  largeDogsDto?: PetDTO;
  negotiable?: boolean;
  none?: boolean;
  smallDogs?: boolean;
  smallDogsDto?: PetDTO;
}

const defaultPetDTO: PetDTO = {
  // TODO: allow for null
  // allowed: false,
  allowed: null,
  count: null,
};

const PetDTO = (props: Partial<PetDTO> = defaultPetDTO): PetDTO => ({
  // allowed: Boolean(props.allowed),
  allowed: typeCheckUtils.Boolean(props.allowed),
  count: typeCheckUtils.isNumeric(props.count) ? typeCheckUtils.Number(props.count) : defaultPetDTO.count,
});

const defaultPetsAllowedProps: PetsAllowedProps = {
  cats: false,
  catsDto: defaultPetDTO,
  largeDogs: false,
  largeDogsDto: defaultPetDTO,
  negotiable: false,
  none: false,
  smallDogs: false,
  smallDogsDto: defaultPetDTO,
};

const PetsAllowed = (props: PetsAllowedProps = defaultPetsAllowedProps) => ({
  cats: Boolean(props.cats),
  catsDto: PetDTO(props.catsDto),
  largeDogs: Boolean(props.largeDogs),
  largeDogsDto: PetDTO(props.largeDogsDto),
  negotiable: Boolean(props.negotiable),
  none: Boolean(props.none),
  smallDogs: Boolean(props.smallDogs),
  smallDogsDto: PetDTO(props.smallDogsDto),
});

export default PetsAllowed;

export type { PetDTO };
export type PetsAllowedReturnType = ReturnType<typeof PetsAllowed>;
